import System from '../System';
import Game from 'Game';
import { TaskEvents } from 'Utility/Task/TaskQueue';
import CleanupManager from 'Utility/CleanupManager';
import { IGameState } from 'State/Game/IGameState';
import Animator from 'Prototype/Animator';
import GameObject from 'GameObject/GameObject';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { AUDIO_PACKS } from 'System/Audio';
import { ResourceDriver } from 'Utility/Resource/ResourceManager';
import { AUDIO_PATH, PlayMusic } from 'System/Audio/AudioHelper';
import { MUSIC_VOLUME_VALUE } from 'Constants/World';
import { AUDIO_CLIP_MUSIC } from 'System/LuckyTurnips/LuckyTurnipsSystemHelper';
const plinkoMusicPath = `${AUDIO_PATH}${AUDIO_CLIP_MUSIC}`;
import { track } from 'Utility/Tracking/Track';
import { TGameArea } from 'Utility/Tracking/DataSet/Transaction';

export default class PlinkoSystem extends System {
    private readonly cleanupManager = new CleanupManager();

    public animator: Animator;

    public init(): void {
        this.taskQueue.on(TaskEvents.START, this.tasksStarted.bind(this));
        this.taskQueue.on(TaskEvents.COMPLETE, this.tasksEnded.bind(this));
    }

    public async preload(): Promise<any> {
        // Load Plinko mini game sound effects using the secondary driver. If audio clips are played before the asset is loaded
        // they are ignored.
        Game.resource.add(AUDIO_PACKS.plinkoMinigameSystem, undefined, ResourceDriver.SECONDARY);

        // Load music with the primary resource driver as it must be loaded before the scene can start. This is a requirement
        // as asynchronously loading sounds and playing once they are loaded is not supported yet.
        Game.resource.add('plinko_music', plinkoMusicPath);

        Game.resource.add('atlas-plinko_minigame', 'resource/graphics/sprite_sheets/plinko-minigame.json');
        Game.resource.add('Plinko_BG', 'resource/graphics/other/Plinko_BG.png');
        addDragonbonesResources('plinko_UI_animations', `${DRAGONBONES_PATH}/PlinkoMinigame/`);

        // Load secondary driver assets asynchronously. This should only be sound effects. Music is required.
        Game.resource.load(ResourceDriver.SECONDARY);

        return Promise.all([Game.resource.load()]);
    }

    public onUpdate(): void { }

    public onStart(): void {
        this.animator = GameObject.Instantiate(Animator);
        this.scene.addGameObject(this.animator);

        PlayMusic('plinko_music', {
            volume: MUSIC_VOLUME_VALUE,
        });
        track('tGameArea', TGameArea.PLINKO_MINIGAME);
    }

    public onDestroy(): void {
        this.taskQueue.off(TaskEvents.START, this.tasksStarted.bind(this));
        this.taskQueue.off(TaskEvents.COMPLETE, this.tasksEnded.bind(this));
    }

    public handleStateChanged(state: IGameState) {
        this.checkQueue(state);
    }

    private checkQueue(state: IGameState) {
        if (!this.isActive() && (!state.gameLoaded || (state.entryPoint?.entryPoint && !state.entryPoint.handled)))
            return;

        if (state.playerState.tasks.length === 0) return;

        //if (!this.taskQueue.some(task => task instanceof PlinkoSyncTask)) this.taskQueue.queue(new PlinkoSyncTask());

        if (state.UIState.popupID === null) {
            this.taskQueue.start(this);
        }
    }

    protected onLateUpdate(): void { }

    protected onStop(): void {
        this.cleanupManager.cleanUpAll();
    }

    protected tasksStarted(): void {
        this.scene.emit(TaskEvents.START);
    }

    protected tasksEnded(): void {
        this.scene.emit(TaskEvents.COMPLETE);
    }
}
